import { type LegalEntityConstructor } from '@webapp/platform/legal-entities/entities/LegalEntity'
import { type LegalEntityApiModel } from '../api-models/LegalEntityApiModel'

const toCount = (value: string | number | null | undefined): number => {
  if (value == null) return 0
  const parsed = typeof value === 'number' ? value : Number.parseInt(value, 10)
  return Number.isFinite(parsed) ? parsed : 0
}

export const mapLegalEntityApiModel = (
  apiModel: LegalEntityApiModel
): LegalEntityConstructor => ({
  id: apiModel.id,
  uuid: apiModel.uuid,
  name: apiModel.name,
  baseCurrencyId: apiModel.base_currency.id,
  baseCurrencyName: apiModel.base_currency.name,
  country: apiModel.country ?? '',
  externalId: apiModel.external_id ?? '',
  active: apiModel.active,
  createdAt: new Date(apiModel.created_at),
  updatedAt: new Date(apiModel.updated_at),
  locationCount: toCount(apiModel.assigned_location_counts),
  userCount: toCount(apiModel.assigned_user_counts),
})
